import React from 'react';
import styled from 'styled-components';
import { media } from '@peloton/styles';
import { trackLinkClick } from '@ecomm/analytics';
import type { HeaderBodyImageWithLinkItem } from '@ecomm/copy/helpers/useHeaderBodyImageWithLinkData';
import { hb5, hb7, hr3 } from '@ecomm/typography';

import BlogCard from './BlogCard';

export type Props = {
  eyebrow: string;
  heading: string;
  page: string;
  blogCards: HeaderBodyImageWithLinkItem[];
};

const BlogCardsModuleView: React.FC<React.PropsWithChildren<Props>> = ({
  eyebrow,
  heading,
  blogCards,
  page,
}) => {
  return (
    <StyledSection>
      <div role="heading" aria-level={2}>
        <Eyebrow data-test-id={`${page}BlogModuleEyebrow`}>{eyebrow}</Eyebrow>
        <Heading data-test-id={`${page}BlogModuleHeading`}>{heading}</Heading>
      </div>

      <CardsContainer>
        {blogCards.map(({ key, ...card }, index) => (
          <BlogCard
            key={card.header}
            {...card}
            page={page}
            cardIndex={index}
            trackLinkClick={trackLinkClick}
          />
        ))}
      </CardsContainer>
    </StyledSection>
  );
};

const StyledSection = styled.section`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;

  text-align: center;

  padding: 64px 16px 32px;

  ${media.iPhone6`
    padding: 64px 24px 32px;
  `}

  ${media.desktopLarge`
    padding: 88px 24px 96px;
  `}
`;

const Eyebrow = styled.p`
  ${hb7}

  margin-bottom: 16px;

  ${media.desktop`
    ${hb5}
  `}
`;

const Heading = styled.p`
  ${hr3}
  margin-bottom: 40px;
  max-width: 275px;

  ${media.iPhone6`
    max-width: 225px;
  `}

  ${media.tablet`
    max-width: 558px;
  `}

  ${media.desktop`
    max-width: 642px;
  `}

  ${media.desktopLarge`
    max-width: 588px;
    margin-bottom: 64px;
  `}
`;

const CardsContainer = styled.div`
  display: flex;
  flex-direction: column;

  ${media.desktopLarge`
    flex-direction: row;
    justify-content: center;

    width: 100%;
    max-width: 1400px;
  `}
`;

export default BlogCardsModuleView;
